// extracted by mini-css-extract-plugin
export var callCard = "_lj-0";
export var callMessageButton = "_lj-1";
export var helpIcon = "_lj-3";
export var helpIconContainer = "_lj-4";
export var verticalDivider = "_lj-2";